import {
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
  INTRO_SLUG,
  QUIZ_ABANDONER_MENU_SUBPATH,
} from '../../routing';
import { ACTION_TYPES, STATE } from '../constants';

export const shouldSkipInterstitialFromPath = asPath =>
  asPath.includes(CHECKOUT_SUBPATH) ||
  asPath.includes(DELETE_PET_SUBPATH) ||
  asPath.includes(QUIZ_ABANDONER_MENU_SUBPATH);

export const shouldRenderPrefetchLoading = ({ propsComponent, stateKey }) =>
  propsComponent === 'redirect_route' || stateKey === STATE.initial;

export const resolvePrefetchLoadingVariant = ({ pathname, petName }) => {
  if (pathname === DELETE_PET_SUBPATH) {
    return { variant: 'deletePet', petName };
  }

  if (pathname === undefined || pathname === INTRO_SLUG) {
    return { variant: 'initial' };
  }

  return { variant: 'default' };
};

export const PLAN_INTERSTITIAL_STATE = {
  loading: 'loading',
  crunching: 'crunching',
  ready: 'ready',
};

export const resolvePlanInterstitialState = ({
  stateKey,
  pathname,
  isLoading,
  skipInterstitial,
  showPlanSelection,
}) => {
  const isOnRecommendedPlanStep =
    stateKey === STATE.recommendedPlan && pathname === stateKey;

  if (!isOnRecommendedPlanStep) return null;

  if (skipInterstitial) {
    return isLoading
      ? PLAN_INTERSTITIAL_STATE.loading
      : PLAN_INTERSTITIAL_STATE.ready;
  }

  return showPlanSelection
    ? PLAN_INTERSTITIAL_STATE.ready
    : PLAN_INTERSTITIAL_STATE.crunching;
};

export const shouldDeferMenuNavigation = ({ actionType, isPlanDataLoading }) =>
  actionType === ACTION_TYPES.toRecommendedPlan && Boolean(isPlanDataLoading);

export const isLegacyPupInfoRoute = key =>
  key === STATE.pupInfo || key === STATE.about;

export const buildRouteChangePayload = ({
  key,
  routerAsPath,
  pets,
  pet_id,
  pet,
  cart,
  customer,
  queryPetId,
}) => {
  if (isLegacyPupInfoRoute(key)) {
    const isNewPet = routerAsPath.includes(CHECKOUT_SUBPATH);

    return {
      pets,
      pet_id: isNewPet ? 'new_pet' : '',
      pet: {},
      cart,
      customer,
      personalizedPlan: false,
    };
  }

  return {
    pets,
    pet,
    pet_id: queryPetId ?? pet_id,
    cart,
    customer,
  };
};
